/*

   Common files for the DEV environment.

   This still talks to the TEST Firebase instance but uses local functions and localhost

*/
import firebase from 'firebase/app'
import 'firebase/functions'

// const serverLoc = 'http://localhost:5001/samanthas-art/us-central1/app/'
const serverBase = 'contrib-test.naloxofind.com'
const serverLoc = 'https://contrib-test.naloxofind.com/'
const emailDomain = 'naloxofind-test.com'

var firebaseConfig = {
    apiKey: "AIzaSyBIX4xIeScf06AyLnQfd_dqo0K-f_b3jYI",
    authDomain: "naloxofind-test.firebaseapp.com",
    databaseURL: "https://naloxofind-test.firebaseio.com",
    projectId: "naloxofind-test",
    storageBucket: "naloxofind-test.appspot.com",
    messagingSenderId: "823906604265"
};

// const mapsAPIkey = "AIzaSyAIDdf82NHO64i78UKsj3-BI0vW3KVHg9k" // For Google Maps NaloxoFind-Test


// const testRecaptchaSiteKey = '6LeE9H8UAAAAAJn1_iYsm4AVbFyZp_Wzt8pb5hlm'

let theFunctions = null
function getFunctions () {
  if (!theFunctions) {
    theFunctions = firebase.functions()
    // theFunctions.useFunctionsEmulator('https://us-central1-naloxofind-test.cloudfunctions.net')
  }
  return theFunctions
}

export default {
  'type' : "dev",
  'serverBase' : serverBase,
  'serverLoc': serverLoc,
  'firebaseConfig': firebaseConfig,
  'getFunctions': getFunctions,
  'emailDomain': emailDomain,
}
